<template>
  <svg
    width="100"
    height="101"
    viewBox="0 0 100 101"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_200_7774)">
      <circle cx="55.0003" cy="58.2273" r="42.2727" fill="#A51B32" fill-opacity="0.21"/>
      <path d="M54.1667 50.4999H66.6667L50 67.1666L33.3333 50.4999H45.8333V33.8333H54.1667V50.4999ZM62.5 17.1666H20.8333V83.8333H79.1667V33.8333H62.5V17.1666ZM12.5 12.9666C12.5 10.6833 14.3625 8.83325 16.6625 8.83325H66.6667L87.5 29.6666V87.9708C87.5038 88.5179 87.3999 89.0605 87.194 89.5675C86.9882 90.0745 86.6845 90.536 86.3003 90.9256C85.9161 91.3152 85.4589 91.6254 84.9548 91.8383C84.4507 92.0512 83.9097 92.1628 83.3625 92.1666H16.6375C15.5432 92.159 14.4959 91.7212 13.7217 90.9478C12.9476 90.1744 12.5087 89.1275 12.5 88.0333V12.9666Z" fill="#142454"/>
    </g>
    <defs>
      <clipPath id="clip0_200_7774">
        <rect width="100" height="100" fill="white" transform="translate(0 0.5)"/>
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: "BaixarCotacao",
}
</script>

<style scoped>

</style>
